import React from 'react';
import { AppGridLayout, AppTableSearch, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar } from 'qcc';
import api, { PosFund } from "api";
import EditForm from "./EditForm";

export default class extends React.Component {
  state = {}

  add = async () => {
    let formData = { type: 0, fundFullName: '', fundName: '', fundTypeName: '', fundCode: '' } as PosFund;
    let title = '新增款项类型';
    let editForm = <EditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title });
  }

  setZskList = async (data?: any) => {
    if (this.refGrid.current && this.refGrid.current.state.refTable) {

      let selected = this.refGrid.current.state.refTable.getSelected();
      if (selected.length === 0) return;

      let idList = selected.map((o: any) => { return `${o.id}` })
      let ids = idList.join(',');

      if (await AppAction.confirm("您确定要将选中的款项设置为暂收款吗？")) {
        await api.posfund.setZskList({ ids });
        AppAction.successMsg("操作成功！");
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      }
    }
  }


  setCancelZskList = async (data?: any) => {
    if (this.refGrid.current && this.refGrid.current.state.refTable) {

      let selected = this.refGrid.current.state.refTable.getSelected();
      if (selected.length === 0) return;

      let idList = selected.map((o: any) => { return `${o.id}` })
      let ids = idList.join(',');

      if (await AppAction.confirm("您确定要将选中的款项取消设置为暂收款吗？")) {
        await api.posfund.setCancelZskList({ ids });
        AppAction.successMsg("操作成功！");
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      }
    }
  }

  setPosSxf = async () => {
    if (this.refGrid.current && this.refGrid.current.state.refTable) {

      let selected = this.refGrid.current.state.refTable.getSelected();
      if (selected.length === 0) return;
      if (selected.length > 1) {
        await AppAction.alert("只能选择一条记录设置为POS手续费！");
        return;
      }

      let id = selected[0].id;
      if (await AppAction.confirm("您确定要选中的款项设置为Pos手续费吗？")) {
        await api.posfund.setPosSxf({ id });
        AppAction.successMsg("操作成功！");
        this.refGrid.current && this.refGrid.current.state.refTable.fetch();
      }
    }

  }

  addFund = async (data?: any) => {
    let fundType = await api.posfund.getOne({ id: data.id });
    let formData = { type: 1, fundFullName: '', fundName: '', fundTypeName: fundType.fundName, fundCode: '' } as PosFund;
    let title = '新增款项名称';
    let editForm = <EditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title });
  }

  edit = async (data?: any) => {
    let formData = await api.posfund.getOne({ id: data.id })
    let { type } = formData;
    let title = type === 1 ? '编辑款项类型' : '编辑款项名称';
    let editForm = <EditForm mode={2} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title });
  }

  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.posfund.delete({ id: data.id });
      AppAction.successMsg('操作成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }


  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppRow style={{ float: 'right', marginRight: 20 }}>
                <AppButton label='新增款项类型' actionCode="66200504" type='primary' action={this.add} />
                <AppButton label='设置暂收款' actionCode="66200505" width={118} >
                  <AppButton.Item label='设置' actionCode="66200505" action={this.setZskList} />
                  <AppButton.Item label='取消' actionCode="66200505" action={this.setCancelZskList} />
                </AppButton>
                <AppButton label='设置POS手续费' actionCode="66200506" action={this.setPosSxf} width={118} />
              </AppRow>
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable parentKeyName='parent_id' sqlId='sql.pos.fundGrid' paging={false} >
            <AppTable.ColCheckbox />
            <AppTable.Col title='款项类型\名称' expand field='fund_name' width={200} />
            <AppTable.Col title='编码' field='fund_code' width={150} />
            <AppTable.Col title='暂收款' field='zsk' width={120} align='center' />
            <AppTable.Col title='POS手续费' field='pos' width={120} align='center' />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right', marginRight: 20 }}>
                {data.type === 0 ? <AppButton type='link' label='新增款项' actionCode="66200501" action={() => this.addFund(data)} /> : null}
                <AppButton type='link' label='编辑' actionCode="66200502" action={() => this.edit(data)} />
                <AppButton type='link' label='删除' actionCode="66200503" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/fund/index.tsx